import './ProgressCircle.less'
import ProgressCircle from './ProgressCircle'

export type { ProgressCircleProps } from './iProgressCircle'

export default ProgressCircle
